export default "https://cdn-static.gokick.com/assets/1a6b0e419037e7f05bc52ad73a019b5bb7bc4745/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";